import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from "../views/Welcome";
import memberRegister1 from "../views/memberRegister";
import memberRegister2 from '../views/memberRegisterVerCode'
import memberRegister3 from '../views/memberRegisterInfo'
import memberRegisterComplete from '../views/memberRegisterComplete'
import memberConsent from "../views/memberConsent";
import forgetPassword from "../views/forgetPassword";
import enterVerCode from "../views/enterVerCode";
import resetPassword from "../views/resetPassword";
import resetComplete from "../views/resetComplete";
import intro from "../views/intro";
import paymentReturn from "../views/paymentReturn";
import paymentReturnError from "../views/paymentReturnError";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // },
    {
        path: '/register/step1',
        name: 'register1',
        component: memberRegister1,
    },
    {
        path: '/register/step2',
        name: 'register2',
        component: memberRegister2,
    },
    {
        path: '/register/step3',
        name: 'register3',
        component: memberRegister3,
    },
    {
        path: '/register/complete',
        name: 'register_complete',
        component: memberRegisterComplete,
    },
    {
        path: '/register/consent/:u_code',
        name: 'consent',
        component: intro
    },
    {
        path: '/register/consent_agree/:u_code',
        name: 'consent',
        component: memberConsent
    },
    {
        path: '/forget_password',
        name: 'forget_password',
        component: forgetPassword
    },
    {
        path: '/enter_verify_code',
        name: 'enter_verify_code',
        component: enterVerCode
    },
    {
        path: '/reset_password',
        name: 'reset_password',
        component: resetPassword
    },
    {
        path: '/reset_complete',
        name: 'reset_complete',
        component: resetComplete
    },
    {
        path: '/payment_spgateway_return',
        name: 'payment_spgateway_return',
        component: paymentReturn
    },
    {
        path: '/payment_spgateway_error',
        name: 'payment_spgateway_error',
        component: paymentReturnError
    },
    {
        path: '/payment_firstbank_return',
        name: 'payment_firstbank_return',
        component: paymentReturn
    },
    {
        path: '/payment_firstbank_error',
        name: 'payment_firstbank_error',
        component: paymentReturnError
    },
    {path: '*', redirect: {name: 'welcome'}}
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

export default router
